import { Component, Input } from '@angular/core';
import { SignatureRequestParticipantViewModel } from '../../models/signature-request.viewmodel';
import { MatTableModule } from '@angular/material/table';
import { SignatureParticipantStatusBadgeComponent } from '../signature-participant-status-badge/signature-participant-status-badge.component';
import { RutPipe } from '../../../../common/rut.pipe';

@Component({
  selector: 'app-signature-request-participant-list-section',
  standalone: true,
  imports: [MatTableModule, SignatureParticipantStatusBadgeComponent, RutPipe ],
  templateUrl: './signature-request-participant-list-section.component.html',
  styleUrls: ['./signature-request-participant-list-section.component.scss']
})
export class SignatureRequestParticipantListSectionComponent {

  /**
   * The list of participants in the signature request.
   */
  @Input() participants: SignatureRequestParticipantViewModel[] = [];
}
